/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";

export class DeadwoodBigWinCountUp extends BitmapWinCountUp {

    private _countUpComplete:boolean;
    private _isShowing:boolean = false;

    private _finishingTimeline:TimelineLite;

    constructor() {
        super({
            font : {
                name : "DeadwoodCountUpFont",
                size : 150
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
    }

    public getCountUpAnimation(from:number, to:number, duration:number):Timeline {
        // Logger.logDev(`------------------------BigWinCountUp.getCountUpAnimation(from: ${from}, to: ${to})`);
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._isShowing = true;
                SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.BIG_WIN_COUNT_UP, 100);
                // Logger.logDev(`------------------------BigWinCountUp.getCountUpAnimation(_isShowing, from: ${from}, to: ${to})`);
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                })
        ]);
        timeline.add(() => this.stopCountUpSound(), "-=0.2");

        return timeline;
    }

    private stopCountUpSound():void {
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.BIG_WIN_COUNT_UP);
    }

    public abort(endValue:number, isAborted:boolean):Timeline | null {
        // Logger.logDev(`------------------------BigWinCountUp.abort(endValue: ${endValue}, isAborted: ${isAborted}, this.alpha = ${this._countUp.alpha})`);
        // Logger.logDev(`------------------------BigWinCountUp.abort(_countUpComplete: ${this._countUpComplete}, this.alpha = ${this._countUp.alpha})`);
        if(this._countUpComplete) {
            return null;
        }

        const timeline:Timeline = super.abort(endValue, isAborted)!;
        timeline.add(() => this.stopCountUpSound(), 0);
        timeline.play();

        return timeline;
    }

    protected getAbortAnimation(endValue:number):Timeline {
        // Logger.logDev(`------------------------BigWinCountUp.getAbortAnimation(endValue: ${endValue}, this.alpha = ${this._countUp.alpha})`);
        this._isShowing = true;
        // Logger.logDev(`------------------------BigWinCountUp.getAbortAnimation(_isShowing)`);
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);

        return timeline;
    }

    public getEndingAnimation(endValue:number):Timeline {
        // Logger.logDev(`------------------------BigWinCountUp.getEndingAnimation(endValue: ${endValue}, this.alpha = ${this._countUp.alpha})`);
        this._countUpComplete = true;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01}));
        return timeline;
    }

    private onBeforeSpinStart():void {
        // Logger.logDev(`------------------------BigWinCountUp.onBeforeSpinStart(_isShowing: ${this._isShowing}, this.alpha = ${this._countUp.alpha})`);
        this._countUpComplete = false;
        if(this._isShowing) {
            this.getRemoveAnimation();
        }
    }

    private getRemoveAnimation():void {
        // Logger.logDev(`------------------------BigWinCountUp.getRemoveAnimation(this.alpha = ${this._countUp.alpha})`);
        this._isShowing = false;

        const timeline = new TimelineLite();
        timeline.add([
            TweenLite.to(this._countUp, 0.5, {alpha : 0, ease : Power2.easeIn}),
            TweenLite.to(this._countUpContainer, 0.5, {y : -100, ease : Power2.easeIn})
        ], `+=0.2`); // stay a while after count up.
        timeline.add(() => this._countUpContainer.y = 0);
        this._finishingTimeline = timeline
    }
}